$(document).ready(function() {
    if($('.homepage-advantages .advantages-slider').html() != undefined) {

		var breakPoint = 992;
		var advantagesSliderOptions = {
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						infinite: true,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						autoplay: true,
						autoplaySpeed: 3000,
						infinite: true,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 993,
					settings: 'unslick'
				}
			]
		};
		var sliderElement = $('.advantages-slider');

		$(window).on('resize', window._debounce(function() {
			var windowWidth = $(window).width();
			if(windowWidth < breakPoint) {
				if(!sliderElement.hasClass('slick-initialized')) {
					sliderElement.slick(advantagesSliderOptions);
				}
			} else {
				if(sliderElement.hasClass('slick-initialized')) {
					sliderElement.slick('unslick');
				}
			}
		}, 100));
		$(window).trigger('resize');

    }
});